import { useAuthContext } from '/src/hooks';

export function useDefaultCurrency() {
  const { currentUser } = useAuthContext();
  const defaultCurrency = currentUser?.settings?.defaultCurrency ?? 'USD';

  return { defaultCurrency };
}
